import { Injectable } from '@angular/core';
import { Subscription } from 'rxjs';

@Injectable()
export abstract class FireflyFroalaLicenseProvider {
  abstract validateLicense(): Subscription | undefined;
  abstract getLicense(): string;
}
